import { SUCCESS, FETCH_VOTE_ROUNDS } from '../constants/actionApi';
import { addOrUpdateItemsInState } from '../helpers/data';
import initialState from '../store/initialState';
import { SC_VOTE_ROUND, UPDATED } from '../constants/socket';

export default (state = initialState.voteRounds, { type, payload }) => {
  switch (type) {
    case FETCH_VOTE_ROUNDS + SUCCESS:
      return addOrUpdateItemsInState(state, payload.data);
    case SC_VOTE_ROUND + UPDATED:
      delete payload.data.answered;
      delete payload.data.points;
      return addOrUpdateItemsInState(state, payload.data);
    default:
      return state;
  }
};
